class CollectionLoadMore extends HTMLElement {
  connectedCallback() {
    this.isLoading = false;
    this.grid = document.querySelector('#product-grid');
    this.progress = this.querySelector('.collection-lm__progress');
    this.progressBar = this.querySelector('.collection-lm__progress-bar');
    this.progressText = this.querySelector('.collection-lm__progress-text');
    this.btn = this.querySelector('.collection-lm__btn');
    this.textEl = this.querySelector('.collection-lm__btn-text');
    this.spinnerEl = this.querySelector('.collection-lm__btn-spinner');

    this.btn?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.btn?.removeEventListener('click', this.onClick);
  }

  onClick = async () => {
    if (this.isLoading || !this.grid) return;

    const nextUrl = this.btn.dataset.nextUrl;
    if (!nextUrl) return;

    this.setLoading(true);

    try {
      const doc = await this.fetchNextPage(nextUrl);
      this.appendNewItems(doc);
      this.updateProgress();
      this.updateButton(doc);
    } catch (err) {
      console.error('Collection load more failed:', err);
      this.setLoading(false);
    }
  };

  async fetchNextPage(url) {
    const res = await fetch(url);
    if (!res.ok) throw new Error(res.statusText);
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  appendNewItems(doc) {
    const newItems = doc.querySelectorAll(
      '#product-grid > .grid__item:not(.grid__item--collection-promo)'
    );
    newItems.forEach((item) => this.grid.appendChild(item));

    if (window.Theme?.animations?.observe) {
      newItems.forEach((item) => window.Theme.animations.observe(item));
    }

    this.refreshJudgeMeBadges();
  }

  refreshJudgeMeBadges() {
    if (typeof window.jdgm?.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
    }
  }

  updateProgress() {
    if (!this.progress || !this.grid) return;
    const viewed = this.grid.querySelectorAll(
      '.grid__item:not(.grid__item--collection-promo)'
    ).length;
    const total = parseInt(this.progress.dataset.total);
    const template = this.progress.dataset.textTemplate;

    this.progressText.textContent =
      template.replace('__VIEWED__', viewed).replace('__TOTAL__', total);
    this.progressBar.style.setProperty('--progress', `${(viewed / total) * 100}%`);
  }

  updateButton(doc) {
    const newBtn = doc.querySelector('.collection-lm__btn');
    if (newBtn && newBtn.dataset.nextUrl) {
      this.btn.dataset.nextUrl = newBtn.dataset.nextUrl;
      this.setLoading(false);
    } else {
      this.remove();
    }
  }

  setLoading(loading) {
    this.isLoading = loading;
    if (loading) {
      this.btn.setAttribute('aria-busy', 'true');
    } else {
      this.btn.removeAttribute('aria-busy');
    }
  }
}

customElements.define('collection-load-more', CollectionLoadMore);
